import { render } from "./ReviewLikes.vue?vue&type=template&id=55838511"
import script from "./ReviewLikes.vue?vue&type=script&lang=js"
export * from "./ReviewLikes.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__